import gsap from 'gsap';
import { isTablet } from '../utils/breakpoints';
const animateGradientText = (element) => {
    const targets = element.querySelectorAll(':scope > h1, :scope > h1 > span, :scope > h2, :scope > h3, :scope > h3 > strong, :scope > h4, :scope > p, :scope > p > strong, :scope > ul > li');
    if (!targets.length)
        return;
    // timeline GSAP
    const tl = gsap.timeline({ paused: true });
    targets.forEach(el => {
        tl.to(el, {
            duration: 0.66,
            ease: "power2.out",
            "--gradient-position": "-0%",
            "--height": "100%",
            "--marker-color": "#353535",
            stagger: 0.1
        }, 0);
        tl.to(el, {
            duration: 0.65,
            ease: "power2.out",
            "--rotate": "0deg",
        }, 1);
    });
    // IntersectionObserver
    const observer = new IntersectionObserver(([entry], obs) => {
        if (!entry.isIntersecting)
            return;
        element.classList.add("is-visible");
        tl.play();
        obs.unobserve(entry.target);
    }, {
        threshold: isTablet ? 0.15 : 0.2,
        rootMargin: "-100px 0px"
    });
    observer.observe(element);
};
const registerGradientText = () => {
    const elements = document.querySelectorAll('[data-anim="text"]');
    elements.forEach(el => animateGradientText(el));
};
export default registerGradientText;
